<template>
  <div>
    <!-- Booking Done Message -->
    <div class="style-container-page mt-3">
      <div class="px-3 mb-5">
        <div class="style-header scss-bold">Done!</div>

        <div class="mt-2">
          <img src="@/assets/icons/green-tick.png" class="style-icon" />
        </div>

        <div class="mt-3 text-center scss-medium-font">
          <p>
            Your purchase has been confirmed. <br/>
            Details have been emailed to you. See you soon!
          </p>
        </div>
      </div>

      <!--
      1. wess-legacy there make sure that if init.allowEstore set to true, init.allowCustomerRedemption will be required set to true.
      2. follwing if block add init.allowCustomerRedemption condition is just to standardized condition usage for consistent reason.
      -->
      <div
        class="style-content mt-3"
        v-if="redemptionTicketId > 0 && sectionsPurchase.length !== 0">
        <nav-tab
          :tabs="sectionsPurchase"
          :selected-tab="selectedTabID"
          @selected-tab="selectedTabID = $event"
          cssClass="scss-fixed-tabs"
          v-if="init.allowCustomerRedemption"
        >
          <div v-for="redemption in purchaseItems" :key="`sectionID-${redemption.sectionID}`">
            <tab :isSelected="selectedTabID === redemption.sectionID">
              <fieldset id="group1">
                <div
                  v-if="
                    redemption.sectionName === 'Services' &&
                    redemption.items.length !== 0
                  "
                >
                  <div v-for="item in redemption.items" :key="item.id">
                    <purchase-item :purchaseItem="item" />
                  </div>
                </div>
                <div
                  v-else-if="
                    redemption.sectionName === 'Coupons' &&
                    redemption.items.length !== 0
                  "
                >
                  <div v-for="item in redemption.items" :key="item.id">
                    <credit-item :purchaseItem="item" />
                  </div>
                </div>
                <div
                  v-else-if="
                    redemption.sectionName === 'Products' &&
                    redemption.items.length !== 0
                  "
                >
                  <div v-for="item in redemption.items" :key="item.id">
                    <purchase-item :purchaseItem="item" :disableButton="true" />
                  </div>
                </div>
                <div v-else>
                  <item-not-found message="No items found." />
                </div>
              </fieldset>
            </tab>
          </div>
        </nav-tab>

        <!-- Homepage Button -->
        <div class="mt-5">
          <default-button title="Home" @click="goToHomePage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";

import { ProductType } from "@/common/constant/ProductType";
import DefaultButton from "@/components/button/DefaultButton.vue";
import ItemNotFound from "@/components/ItemNotFound";
import NavTab from "@/components/tab/NavTab";
import Tab from "@/components/tab/Tab";
import PurchaseItem from "@/views/MyAccount/MyRedemption/components/PurchaseItem";
import CreditItem from "@/views/MyAccount/MyRedemption/components/CreditItem";

export default {
  name: "CheckOutSuccess",
  components: {
    DefaultButton,
    NavTab,
    Tab,
    PurchaseItem,
    CreditItem,
    ItemNotFound
  },
  data() {
    return {
      redemptionTicketId: null,
      selectedTabID: null,
      purchaseItems: [
        {
          sectionID: 1,
          sectionName: "Services",
          items: [],
        },
        {
          sectionID: 2,
          sectionName: "Products",
          items: [],
        },
        {
          sectionID: 3,
          sectionName: "Coupons",
          items: [],
        },
      ],
    };
  },
  computed: {
    sectionsPurchase() {
      return [
        { id: 1, name: `Services (${this.purchaseItems[0].items.length})` },
        { id: 2, name: `Products (${this.purchaseItems[1].items.length})` },
        {
          id: 3,
          name: `Coupons (${this.purchaseItems[2].items.length})`,
        },
      ];
    },

    ...mapGetters([
      "init",
      "redemptions",
    ]),
  },
  methods: {
    goToHomePage() {
      this.$router.push("/home");
    },
    async initData() {
      this.showLoading(true);
      this.redemptionTicketId = sessionStorage.getItem("stripePaymentTicketId");
      // sessionStorage store value as string,
      // storing null or undefined in sessionStorage result in 'null' or 'undefined'
      // following use implicitly comparison since valid ticket id is > 0
      if (this.redemptionTicketId > 0) {
        try {
          await this.getRemptionListByTicket({
            ticketId: this.redemptionTicketId,
          });

          this.redemptions.map((redemption) => {
            const type = redemption.product.type;
            if (type === ProductType.SERVICE) {
              this.purchaseItems[0].items.push(redemption);
            } else if (type === ProductType.RETAIL_PRODUCT) {
              this.purchaseItems[1].items.push(redemption);
            } else if (type === ProductType.COUPON) {
              this.purchaseItems[2].items.push(redemption);
            }
          });
        } catch (error) {
          useToast().error(
            "There is some problem during loading, please refresh to try again."
          );
        }
      }

      this.showLoading(false);
    },
    ...mapActions(["getRemptionListByTicket", "showLoading"]),
  },
  created() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.style-container-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-header {
  color: $text-green;
  font-size: 18px;
}

.style-content {
  width: 90%;
  margin: 0 auto 0 auto;
  margin-bottom: 70px;
}

.style-icon {
  width: 30%;
  height: 30%;
}

</style>
